/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

import type { ARTransform, ImagePolicy } from './BVatom'

export interface FacePayload {
  id: string
  properties: {
    config: {
      image: string
      scale: string
      image_mode: string
      image_policy: ImagePolicy[]
      layerImage: string
      empty_image: string
      full_image: string
      padding_start: number
      padding_end: number
      direction: string

      // For video
      cover: string
      video: string

      // For crate
      unlock_key: string
      activate_action: string

      // For 3d
      scene: string
      animation_rules?: AnimationRule[]
      ar_transform?: ARTransform
      auto_rotate?: boolean

      bgColor: {
        r: number
        g: number
        b: number
        a: number
      }
    }
    constraints: {
      platform: string
      view_mode: string
    }
    resources: string[]
    display_url: string
  }
  meta: any
  template: string
}

export type AnimationRule = {
  on: string
  play: string
  target: string
  value?: string
}

export default class Face {
  payload: FacePayload

  constructor(payload: FacePayload) {
    this.payload = payload
  }

  get properties() {
    return this.payload.properties
  }

  get config() {
    return this.payload.properties.config
  }

  get template() {
    return this.payload.template
  }

  get meta() {
    return this.payload.meta
  }
}
